import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const BannerContainer = styled(Box)`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: ${({ theme }) => theme.zIndex.modal};
    background-color: ${({ theme }) => theme.colors.tertiary};
    padding: ${({ theme }) => theme.spacing(3)};
`;
